import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-component-button-header-back',
    templateUrl: './button-header-back.component.html',
    styleUrls: ['./button-header-back.component.scss']
})
export class ButtonHeaderBackComponent  {
    @Input() href!: string;
    @Input() marginLeft: string|null=null;
}
